var _g, _path, _path2, _path3, _path4, _path5, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 86,
    height: 19,
    viewBox: "0 0 86 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4915_3762)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1718 3.979H-0.0136719V8.89899H15.9765C14.9454 7.31489 13.9769 5.69392 13.1718 3.979Z",
    fill: "url(#paint0_linear_4915_3762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.1843 12.1771C17.4425 11.0884 16.6953 10.0026 15.9771 8.89893H-0.0136719V13.8189H19.2723C18.9149 13.2683 18.5541 12.72 18.1843 12.1771Z",
    fill: "url(#paint1_linear_4915_3762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.2723 13.8188H-0.0136719V18.7388H22.3864C21.3464 17.1 20.3295 15.4464 19.2723 13.8188Z",
    fill: "url(#paint2_linear_4915_3762)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.1699 3.979L27.8908 18.739H29.6886C30.7943 18.739 31.6906 17.8381 31.6906 16.7267L22.4073 3.979H17.1699Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.6917 5.99124C31.6917 4.87987 30.7954 3.979 29.6897 3.979H25.3125L31.6911 12.7611V5.99124H31.6917Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.25391 3.979L19.8866 18.739H25.0116L14.2629 3.979H9.25391Z",
    fill: "white"
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M36.3849 4.40899V18.7382H33.0781V4.40899H36.3849ZM36.3849 0V3.30674H33.0781V0H36.3849Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M37.4871 11.0225C37.4871 8.89147 38.2403 7.07276 39.7467 5.56635C41.2531 4.05995 43.0718 3.30674 45.2029 3.30674V6.61349C43.983 6.61349 42.9432 7.04336 42.0835 7.90312C41.2237 8.76287 40.7939 9.80266 40.7939 11.0225V18.7382H37.4871V11.0225Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M58.1212 9.36911C57.9081 8.83268 57.5811 8.34402 57.1402 7.90312C56.2804 7.04336 55.2407 6.61349 54.0208 6.61349C52.801 6.61349 51.7612 7.04336 50.9015 7.90312C50.4606 8.34402 50.1336 8.83268 49.9205 9.36911H58.1212ZM57.4709 13.7781H61.2516C60.8768 14.7701 60.2853 15.6703 59.477 16.4786C57.9706 17.985 56.1518 18.7382 54.0208 18.7382C51.8898 18.7382 50.0711 17.985 48.5647 16.4786C47.0583 14.9722 46.3051 13.1535 46.3051 11.0225C46.3051 8.89147 47.0583 7.07276 48.5647 5.56635C50.0711 4.05995 51.8898 3.30674 54.0208 3.30674C56.1518 3.30674 57.9706 4.05995 59.477 5.56635C60.9834 7.07276 61.7366 8.89147 61.7366 11.0225C61.7366 11.5956 61.6815 12.1468 61.5712 12.6759H49.9205C50.1336 13.2123 50.4606 13.7009 50.9015 14.1418C51.7612 15.0016 52.801 15.4315 54.0208 15.4315C55.2407 15.4315 56.2804 15.0016 57.1402 14.1418C57.2578 14.0243 57.368 13.903 57.4709 13.7781Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M63.5838 17.4515L69.3627 11.3565C69.9496 10.7545 70.4086 10.2353 70.7397 9.79889C71.0708 9.34741 71.3041 8.93356 71.4395 8.55732C71.59 8.18109 71.6653 7.78981 71.6653 7.38347C71.6653 6.58586 71.4094 5.96131 70.8978 5.50983C70.3861 5.05835 69.7239 4.83261 68.9112 4.83261C68.1136 4.83261 67.4138 5.02825 66.8118 5.41953C66.2099 5.79577 65.6756 6.38269 65.2091 7.18031L63.7192 5.93874C64.3362 4.91538 65.0812 4.14786 65.954 3.63618C66.8269 3.10945 67.8352 2.84609 68.979 2.84609C69.9421 2.84609 70.7774 3.03421 71.4847 3.41044C72.207 3.78668 72.7639 4.3134 73.1552 4.99063C73.5464 5.66785 73.7421 6.45794 73.7421 7.3609C73.7421 8.00802 73.6593 8.58742 73.4938 9.0991C73.3433 9.61078 73.0649 10.1375 72.6585 10.6793C72.2672 11.206 71.7179 11.8381 71.0106 12.5755L66.3378 17.3838L63.5838 17.4515ZM63.5838 18.7382V17.4515L65.3897 16.842H74.1033V18.7382H63.5838Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M73.9907 13.343L79.702 3.07183H82.0948L76.2707 13.343H73.9907ZM73.9907 14.6523V13.343L74.8937 12.7561H86.0001V14.6523H73.9907ZM81.6433 18.7382V8.37673H83.7427V18.7382H81.6433Z",
    fill: "white"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4915_3762",
    x1: -0.0136719,
    y1: 6.43899,
    x2: 10.1481,
    y2: 6.43899,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_4915_3762",
    x1: 2.08589,
    y1: 11.3589,
    x2: 16.1705,
    y2: 11.3589,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_4915_3762",
    x1: 5.96438,
    y1: 16.2788,
    x2: 26.12,
    y2: 16.2788,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4915_3762"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 31.6905,
    height: 14.7599,
    fill: "white",
    transform: "translate(0 3.979)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo2);
export default __webpack_public_path__ + "static/media/logo2.398816d5416b3fa425284e4b5bbe4256.svg";
export { ForwardRef as ReactComponent };